import { render, staticRenderFns } from "./agv-sbol-payment-help.vue?vue&type=template&id=f2f0acf6&scoped=true&lang=pug&"
import script from "./agv-sbol-payment-help.vue?vue&type=script&lang=js&"
export * from "./agv-sbol-payment-help.vue?vue&type=script&lang=js&"
import style0 from "./agv-sbol-payment-help.vue?vue&type=style&index=0&id=f2f0acf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f0acf6",
  null
  
)

export default component.exports